!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.si = t());
}(this, function () {
  "use strict";

  return [{
    locale: "si",
    pluralRuleFunction: function (e, t) {
      var r = String(e).split("."),
        a = r[0],
        o = r[1] || "";
      return t ? "other" : 0 == e || 1 == e || 0 == a && 1 == o ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "වර්ෂය",
        relative: {
          0: "මෙම වසර",
          1: "ඊළඟ වසර",
          "-1": "පසුගිය වසර"
        },
        relativeTime: {
          future: {
            one: "වසර {0}කින්",
            other: "වසර {0}කින්"
          },
          past: {
            one: "වසර {0}කට පෙර",
            other: "වසර {0}කට පෙර"
          }
        }
      },
      "year-short": {
        displayName: "වර්.",
        relative: {
          0: "මෙම වසර",
          1: "ඊළඟ වසර",
          "-1": "පසුගිය වසර"
        },
        relativeTime: {
          future: {
            one: "වසර {0}කින්",
            other: "වසර {0}කින්"
          },
          past: {
            one: "වසර {0}කට පෙර",
            other: "වසර {0}කට පෙර"
          }
        }
      },
      month: {
        displayName: "මාසය",
        relative: {
          0: "මෙම මාසය",
          1: "ඊළඟ මාසය",
          "-1": "පසුගිය මාසය"
        },
        relativeTime: {
          future: {
            one: "මාස {0}කින්",
            other: "මාස {0}කින්"
          },
          past: {
            one: "මාස {0}කට පෙර",
            other: "මාස {0}කට පෙර"
          }
        }
      },
      "month-short": {
        displayName: "මාස.",
        relative: {
          0: "මෙම මාස.",
          1: "ඊළඟ මාස.",
          "-1": "පසුගිය මාස."
        },
        relativeTime: {
          future: {
            one: "මාස {0}කින්",
            other: "මාස {0}කින්"
          },
          past: {
            one: "මාස {0}කට පෙර",
            other: "මාස {0}කට පෙර"
          }
        }
      },
      day: {
        displayName: "දිනය",
        relative: {
          0: "අද",
          1: "හෙට",
          2: "අනිද්දා",
          "-2": "පෙරේදා",
          "-1": "ඊයේ"
        },
        relativeTime: {
          future: {
            one: "දින {0}න්",
            other: "දින {0}න්"
          },
          past: {
            one: "දින {0}කට පෙර",
            other: "දින {0}කට පෙර"
          }
        }
      },
      "day-short": {
        displayName: "දිනය",
        relative: {
          0: "අද",
          1: "හෙට",
          2: "අනිද්දා",
          "-2": "පෙරේදා",
          "-1": "ඊයේ"
        },
        relativeTime: {
          future: {
            one: "දින {0}න්",
            other: "දින {0}න්"
          },
          past: {
            one: "දින {0}කට පෙර",
            other: "දින {0}කට පෙර"
          }
        }
      },
      hour: {
        displayName: "පැය",
        relative: {
          0: "මෙම පැය"
        },
        relativeTime: {
          future: {
            one: "පැය {0}කින්",
            other: "පැය {0}කින්"
          },
          past: {
            one: "පැය {0}කට පෙර",
            other: "පැය {0}කට පෙර"
          }
        }
      },
      "hour-short": {
        displayName: "පැය",
        relative: {
          0: "මෙම පැය"
        },
        relativeTime: {
          future: {
            one: "පැය {0}කින්",
            other: "පැය {0}කින්"
          },
          past: {
            one: "පැය {0}කට පෙර",
            other: "පැය {0}කට පෙර"
          }
        }
      },
      minute: {
        displayName: "මිනිත්තුව",
        relative: {
          0: "මෙම මිනිත්තුව"
        },
        relativeTime: {
          future: {
            one: "මිනිත්තු {0}කින්",
            other: "මිනිත්තු {0}කින්"
          },
          past: {
            one: "මිනිත්තු {0}කට පෙර",
            other: "මිනිත්තු {0}කට පෙර"
          }
        }
      },
      "minute-short": {
        displayName: "මිනි.",
        relative: {
          0: "මෙම මිනිත්තුව"
        },
        relativeTime: {
          future: {
            one: "මිනිත්තු {0}කින්",
            other: "මිනිත්තු {0}කින්"
          },
          past: {
            one: "මිනිත්තු {0}කට පෙර",
            other: "මිනිත්තු {0}කට පෙර"
          }
        }
      },
      second: {
        displayName: "තත්පරය",
        relative: {
          0: "දැන්"
        },
        relativeTime: {
          future: {
            one: "තත්පර {0}කින්",
            other: "තත්පර {0}කින්"
          },
          past: {
            one: "තත්පර {0}කට පෙර",
            other: "තත්පර {0}කට පෙර"
          }
        }
      },
      "second-short": {
        displayName: "තත්.",
        relative: {
          0: "දැන්"
        },
        relativeTime: {
          future: {
            one: "තත්පර {0}කින්",
            other: "තත්පර {0}කින්"
          },
          past: {
            one: "තත්පර {0}කට පෙර",
            other: "තත්පර {0}කට පෙර"
          }
        }
      }
    }
  }];
});